<template>
  <div class="fullheight" style="padding-top: 16px; height: calc(100% - 16px)">
    <div
      class="fullheight2"
      :style="{
        height: height
      }"
    >
      <div class="fullheight">
        <eco-table
          @load="loadData"
          :data="templateData"
          :page-result="pageBean"
          quick-search-props="F_template_no"
          ref="ecoTable"
          :show-export="false"
          :show-custom-column="false"
          @select="tableSelect"
          @select-all="tableSelect"
        >
          <template v-slot:toolbar>
            <el-button size="small" @click="showAddTemp()" type="primary" v-if="activeName == 'first'">添加</el-button>
            <el-button size="small" @click="delTemp" class="marginLeft16" v-if="activeName == 'first'">删除</el-button>
          </template>
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="F_template_no" label="模板编号" min-width="200" :show-overflow-tooltip="true" :sortable="true">
              <template slot-scope="scope">
                {{ scope.row.template_no }}
              </template>
            </eco-table-column>
            <eco-table-column prop="matter" label="事项" min-width="200" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ $utils.findAllDataDict(scope.row.matter, 'sx', allDataDict) }}
              </template>
            </eco-table-column>
            <eco-table-column prop="create_user" label="编制人" min-width="200" :show-overflow-tooltip="true" />
            <eco-table-column prop="create_time" label="编制日期" min-width="200" :show-overflow-tooltip="true" />
            <eco-table-column label="操作" width="200">
              <template v-slot="{ row }">
                <el-link type="primary" :underline="false" @click="temModify(row.id)">编辑</el-link>
              </template>
            </eco-table-column>
          </template>
        </eco-table>
      </div>
      <!--模板添加-->
      <temp-add v-if="taVisible" :dialogVisible="taVisible" @beforeClose="beforeTaClose"></temp-add>
      <!--模板编辑-->
      <temp-modify
        v-if="tmVisible"
        :title="activeName == 'first' ? '编辑模板' : '查看模板'"
        :dialogVisible="tmVisible"
        :selectModel="selectModel"
        @beforeClose="beforeTmClose"
      ></temp-modify>
    </div>
  </div>
</template>

<script>
import form from '@/api/form.js'
import { mapState } from 'vuex'
const tempAdd = () => import('@/views/form/approvalReportTemplate/tempAdd.vue')
const tempModify = () => import('@/views/form/approvalReportTemplate/tempModify.vue')
export default {
  components: {
    tempAdd,
    tempModify
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  data() {
    return {
      activeName: 'first',
      pageBean: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      height: '98%',
      templateData: [],
      updateTableData: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false
    }
  },
  mounted() {
    // this.height = 'calc(100% - 56px)'
  },
  methods: {
    // tab切换
    handleClick(tab) {
      this.templateData = []
      this.pageBean.page = 1
      this.$refs.ecoTable.quickSearchWord = ''
      this.activeName = tab.name
      this.$refs.ecoTable.$refs.ecoTable.doLayout()
      this.loadData()
    },
    //设置默认
    setDefault(row) {
      form.setDefault(row.id, row.templateType).then((resp) => {
        if (resp.data.state) {
          this.$message({ message: resp.data.message, type: 'success' })
          this.loadData()
        } else {
          this.$message({ message: resp.data.message, type: 'error' })
        }
      })
    },
    //初始化加载
    loadData(param, cb) {
      if (!param) {
        this.pageBean.total = 0
        param = {
          pageBean: '',
          sorter: []
        }
        param.pageBean = this.pageBean
      }
      let loadUrl = 'getOaContractTemplateList'
      form[loadUrl](param)
        .then((resp) => {
          this.templateData = []
          this.templateData = resp.rows
          this.pageBean = {
            page: resp.page,
            pageSize: resp.pageSize,
            total: resp.total
          }
        })
        .finally(() => {
          if (cb) {
            cb()
          }
        })
    },
    transDict(value, list) {
      let a = list.find((item) => item.code === value)
      return a ? a.name : ''
    },
    changeStatus(row) {
      let params = {
        id: row.id,
        status: row.status ? 0 : 1
      }
      form.getContractTemplatePublish(params).then((res) => {
        if (res.state) {
          this.$message.success(res.message)
          this.loadData()
        }
      })
    },
    handleCommand(params) {
      switch (params.command) {
        case 'modify':
          this.temModify(params.row.id)
          break
        case 'delete':
          this.temDel(params.row.id)
          break
        case 'newVersion':
          this.temNewVersion(params.row.id)
          break
      }
    },
    // 发布新版
    temNewVersion(id) {
      let params = {
        id: id
      }
      form.getDetailListByNewVersion(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: resp.message,
            type: 'success'
          })
          this.loadData(this.pageBean)
        } else {
          this.$message({
            message: resp.message,
            type: 'error'
          })
        }
      })
    },
    // 删除
    temDel(id) {
      let params = {
        id: id
      }
      form.getContractTemplateRemove(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData(this.pageBean)
        } else {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        }
      })
    },
    // 展示添加模板
    showAddTemp() {
      this.taVisible = true
    },
    temModify(id) {
      this.selectModel = id
      this.tmVisible = true
    },
    // 关闭temp上传
    beforeTaClose() {
      this.selectModel = null
      this.taVisible = false
      this.loadData()
    },
    // 关闭temp上传
    beforeTmClose() {
      this.selectModel = null
      this.tmVisible = false
      this.loadData()
    },
    //表格选中数据
    tableSelect(selection) {
      this.updateTableData = selection
    },
    // 删除模板
    delTemp() {
      let that = this
      let id = []
      for (let i = 0; i < that.updateTableData.length; i++) {
        id.push(that.updateTableData[i].id)
      }
      let params = {
        ids: id
      }
      form.delOaContractTemplate(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          that.$refs.ecoTable.load()
        } else {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
